module.exports = __webpack_public_path__ + "assets/img/live18_app.a3332815.png";